import { SET_COUNTY } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTY: {
      return action.payload;
    }
    default:
      return state;
  }
};
